import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '@equine-ui-nx/account';
import { MatSnackBar } from '@angular/material/snack-bar';

export const roleGuard: CanActivateFn = (route, state) => {
  const authService = inject(AuthService);
  const router: Router = inject(Router);
  const _snackBar = inject(MatSnackBar);
  const roleList = route.data['authorizedRole'];
  const isValidRole = (roleList && roleList.length) ? roleList.includes(authService.getUserRole()) : false;
     if (!isValidRole) {
       _snackBar.open('User does not have role to access!', 'close', {
         duration: 1000,
         panelClass: ['error-snackbar']
       });
     }
  return isValidRole;
};
/*
{
  "email": "aziz.ansari+3@innate.ly",
  "password": "Admin@12345",
  "confirmPassword": "Admin@12345"
}
*/